import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Preloader from './Preloader';

export default class GlobalPreloader extends React.Component {
  static defaultProps = {
    layoutClass: '',
    mainClass: '',
    contentClass: '',
    modalCloseButton: true,
  };

  static propTypes = {
    layoutClass: PropTypes.string,
    mainClass: PropTypes.string,
    contentClass: PropTypes.string,
    modalCloseButton: PropTypes.bool,
    children: PropTypes.any,
  };

  componentWillMount() {
    this.root = document.createElement('div');
    document.body.appendChild(this.root);
  }

  componentWillUnmount() {
    document.body.removeChild(this.root);
  }

  render() {
    const {
      layoutClass, mainClass, contentClass, modalCloseButton,
    } = this.props;

    return ReactDOM.createPortal(
      <div className={classNames('modal-layout -preloader', layoutClass)}>
        <div className={classNames('modal-main', mainClass)} style={{width: 'auto', maxWidth: '320px'}}>
          <div className={classNames('modal-content', 'clearfix', contentClass)} style={{textAlign: 'center', padding: '40px 20px'}}>
            {this.props.children || 'Ваш запрос обрабатывается'}
            <Preloader />
          </div>
        </div>
      </div>,

      this.root,
    );
  }
}
